import { render, staticRenderFns } from "./buttonsForm.vue?vue&type=template&id=4468ea5c&scoped=true&lang=html&"
import script from "./buttonsForm.vue?vue&type=script&lang=js&"
export * from "./buttonsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4468ea5c",
  null
  
)

export default component.exports